import { UploadErrorCode, UploadTaskStatus } from '@fabric-app/types/upload';
import { executeUploadRequest } from './executeUploadRequest.js';
import { logUploadTaskEvent, uploadStore, logUploadTaskError } from '../upload.store.js';
import { UploadError } from '../upload.error.js';
import { ensureError } from '@fabric-app/utils/guards';

const uploadChunk = async (taskId, chunkIndex, options, progressTracker) => {
  logUploadTaskEvent(taskId, `Uploading chunk ${chunkIndex}...`);
  try {
    if (options.abortSignal?.aborted) {
      throw new UploadError(UploadErrorCode.FileUploadCancelled);
    }
    const store = uploadStore.getState();
    const task = store.tasks.find((t) => t.id === taskId);
    const currentChunk = task?.chunks.find((c) => c.index === chunkIndex);
    if (!task) {
      throw new UploadError(UploadErrorCode.UploadTaskMissing);
    }
    if (!currentChunk) {
      throw new UploadError(UploadErrorCode.UploadChunkMissing);
    }
    logUploadTaskEvent(taskId, `Uploading chunk ${chunkIndex}... (${currentChunk.retries} retries)`);
    store.updateChunk(taskId, currentChunk.index, (chunk) => ({
      ...chunk,
      status: UploadTaskStatus.Uploading
    }));
    if (!currentChunk.link) {
      throw new UploadError(UploadErrorCode.ChunkMissingLink);
    }
    const { url, headers } = currentChunk.link;
    const uploadResult = await executeUploadRequest({
      url,
      headers,
      method: "PUT",
      data: task.data,
      chunk: {
        index: currentChunk.index,
        size: task.chunkSize
      },
      onProgress: (progress, uploadSpeed) => progressTracker.onChunkProgress(currentChunk.index, progress, uploadSpeed),
      abortSignal: options.abortSignal
    });
    logUploadTaskEvent(taskId, `Chunk ${chunkIndex} uploaded. Response: ${JSON.stringify(uploadResult)}`);
    store.completeChunk(taskId, currentChunk.index, {
      etag: uploadResult.responseHeaders["etag"]
    });
    return;
  } catch (_error) {
    const store = uploadStore.getState();
    const error = _error instanceof UploadError ? _error : new UploadError(UploadErrorCode.Unknown, ensureError(_error).message, true, false);
    logUploadTaskError(taskId, ensureError(error), `Chunk ${chunkIndex} upload failed.`);
    store.failChunk(taskId, chunkIndex, error);
  }
};

export { uploadChunk };
//# sourceMappingURL=uploadChunk.js.map
